import { LegacyCard, IndexTable, Text, Link, LegacyStack, Pagination, Badge, Divider } from '@shopify/polaris';
import { useEffect, useState, useContext, forwardRef, useImperativeHandle } from 'react';
import { listUsers } from '../../../services/userService';
import { useHistory } from 'react-router-dom';
import { SET_ERROR } from '../../../context/ToastReducer';
import ToastContext from '../../../context/ToastContext';
import moment from 'moment';
import { listRoles } from '../../../services/rolesService';

const ListUsers = forwardRef(({ page }, ref) => {
  const [, dispatchToast] = useContext(ToastContext);
  const history = useHistory();
  const showUserEndpoint = (id) => `/users/${id}/edit?r=${window.btoa('/users/page/' + response.metadata.page)}`;

  const [response, setResponse] = useState(null);
  const [rows, setRows] = useState([]);
  const [roles, setRoles] = useState([]);

  useImperativeHandle(ref, () => ({
    last(e = { new: false }) {
      callDB(e.new ? Math.ceil((response.metadata.count + 1) / response.metadata.limit) : response.metadata.lastPage);
    },
  }));

  const callDB = (page = 1, limit = 10) =>
    listUsers({ page, limit })
      .then((res) => {
        setResponse(res.data);
        history.push(`/users/page/${page}`);
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
        callDB();
      });

  useEffect(
    () => {
      listRoles().then((p) => {
        setRoles(p.data.roles);
        callDB(page);
      });
    },
    // eslint-disable-next-line
    [],
  );

  useEffect(() => {
    response && setRows(response.data.map((r, k) => rowMarkup(r, k)));
    //eslint-disable-next-line
  }, [response]);

  const rowMarkup = ({ id, name, surname, email, phone, lastLogin, role }, index) => (
    <IndexTable.Row id={id} key={id} position={index}>
      <IndexTable.Cell>
        <Link dataPrimaryLink url={showUserEndpoint(id)}></Link>
        <Text variant="bodyMd" fontWeight="bold" as="span">
          {[name, surname].join(' ')}
        </Text>
      </IndexTable.Cell>
      <IndexTable.Cell>{email}</IndexTable.Cell>
      <IndexTable.Cell>
        <Badge size="small">{roles.find(({ slug }) => slug === role)?.name}</Badge>
      </IndexTable.Cell>
      <IndexTable.Cell>{!lastLogin ? '' : moment(lastLogin).format('DD-MM-YYYY')}</IndexTable.Cell>
    </IndexTable.Row>
  );

  const headingMarkup = [{ title: 'Nombre' }, { title: 'Email' }, { title: 'Rol' }, { title: 'Última conexión' }];

  return (
    <>
      {response && (
        <>
          <IndexTable
            resourceName={{
              singular: 'usuario',
              plural: 'usuarios',
            }}
            itemCount={rows.length}
            headings={headingMarkup}
            selectable={false}
          >
            {rows}
          </IndexTable>
          <Divider borderStyle="divider" />
          <LegacyCard.Section>
            <LegacyStack distribution="center">
              <Pagination
                hasPrevious={response.metadata.prev}
                onPrevious={() => callDB(response.metadata.page - 1, response.metadata.limit)}
                hasNext={response.metadata.next}
                onNext={() => callDB(response.metadata.page + 1, response.metadata.limit)}
              />
            </LegacyStack>
          </LegacyCard.Section>
        </>
      )}
    </>
  );
});

export default ListUsers;
